/**
 * "Lembrar login" do Portal Parceiros — chaves separadas do operacional (gscmx-frontend-v2).
 */
export const LS_LOGIN_REMEMBER = 'gescomex_portal_parceiros_login_remember';
export const LS_LOGIN_USERNAME = 'gescomex_portal_parceiros_login_username';
export const LS_LOGIN_PASSWORD_ENC = 'gescomex_portal_parceiros_login_password_enc';

export function snapshotLoginRemember() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  const remember = window.localStorage.getItem(LS_LOGIN_REMEMBER);
  if (remember !== 'true') {
    return null;
  }
  return {
    remember,
    username: window.localStorage.getItem(LS_LOGIN_USERNAME),
    passwordEnc: window.localStorage.getItem(LS_LOGIN_PASSWORD_ENC),
  };
}

export function restoreLoginRemember(snapshot) {
  if (!snapshot || snapshot.remember !== 'true') {
    return;
  }
  window.localStorage.setItem(LS_LOGIN_REMEMBER, snapshot.remember);
  if (snapshot.username != null) {
    window.localStorage.setItem(LS_LOGIN_USERNAME, snapshot.username);
  }
  if (snapshot.passwordEnc != null) {
    window.localStorage.setItem(LS_LOGIN_PASSWORD_ENC, snapshot.passwordEnc);
  }
}

/** Se no futuro o logout passar a usar localStorage.clear(), preservar o lembrete. */
export function clearLocalStoragePreservingLoginRemember() {
  const snap = snapshotLoginRemember();
  window.localStorage.clear();
  restoreLoginRemember(snap);
}
